import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { backendPagination, rowsPerPage as defaultRowsPerPage } from '../../../app/app-constant';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  //encapsulation: ViewEncapsulation.None
})
export class PaginationComponent implements OnInit {
  
  @Input() data;
  @Input() rowsPerPage;
  @Input() rowsPerPageOptions = [];
  @Input() totalRecords;
  @Output() filterEvent: any  = new EventEmitter();
  totalPages = 0;
  pages: any = [];
  currentPage: any = 1;
  updateDataInitiator = false;

  constructor() { }

  ngOnInit() {
    let that = this;
    let totlePagesInterval = setInterval(function() {
      let totalPages = that.setTotalPages();
      if(totalPages > 0) {
        clearInterval(totlePagesInterval);
      }
    }, 1000);
  }

  ngOnChanges(changes) {
    if(changes.data && !changes.data.firstChange) {
      if(!this.updateDataInitiator) {
        this.currentPage = 1;
        this.rowsPerPage = defaultRowsPerPage;
        this.setTotalPages();
      }
      this.updateDataInitiator = false;
    }
  }

  setTotalPages() {
    //console.log(this.data, this.rowsPerPage, this.rowsPerPageOptions, this.totalRecords);
      this.totalPages = this.totalRecords % this.rowsPerPage ? 
                          Math.ceil(this.totalRecords / this.rowsPerPage) : 
                          this.totalRecords / this.rowsPerPage;
      //console.log(this.totalPages);
      this.pages = Array(this.totalPages).fill(1).map((x, i) => i+1);
      return this.totalPages;
  }

  changeRowsPerPage() {
    let that = this;
    this.currentPage = 1;
    this.setTotalPages();
    this.updateDataInitiator = true;
    this.filterEvent.next({
      first: 0,
      rows: that.rowsPerPage,
      sortField: null,
      sortOrder: null
    });
  }

  changePage(pageNavigation?: any) {
    let that = this;
    this.currentPage = parseInt(that.currentPage);
    this.currentPage = pageNavigation ? (pageNavigation == 'NEXT' ? that.currentPage + 1 : that.currentPage - 1) : that.currentPage;
    this.updateDataInitiator = true;
    this.filterEvent.next({
      first: (that.currentPage - 1) * that.rowsPerPage,
      rows: that.rowsPerPage,
      sortField: null,
      sortOrder: null
    });
  }

}
